export default __webpack_public_path__ + "static/media/windchimes.23c464fb.mp3";